import { render, staticRenderFns } from "./NavigationAdmin.vue?vue&type=template&id=285b7f65&scoped=true"
import script from "./NavigationAdmin.vue?vue&type=script&lang=js"
export * from "./NavigationAdmin.vue?vue&type=script&lang=js"
import style0 from "./NavigationAdmin.vue?vue&type=style&index=0&id=285b7f65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285b7f65",
  null
  
)

export default component.exports